import { Button } from "@mantine/core";
import React from "react";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { changeRuleStatus } from "../../../../../services/rules";
import { getAxiosResponseError } from "../../../../../utils/functions";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { setReportStatus } from "../../../../../redux/features/customReport/customReportsSlice";

export default function ActivateDeactivateButton({ status, id, period }) {
  const dispatch = useDispatch();
  const isActive = status === "ACTIVATED";

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      changeRuleStatus({
        id,
        date: dayjs(new Date()).format("YYYY-MM-DD"),
        status: isActive ? "DEACTIVATED" : "ACTIVATED",
        period,
      }),
    onSuccess: () => {
      const nextStatus = isActive ? "DEACTIVATED" : "ACTIVATED";
      dispatch(setReportStatus({ id, status: nextStatus }));
      toast.success(
        `Report has been ${isActive ? "deactivated" : "activated"}`,
      );
    },
    onError: (err) => {
      toast.error(getAxiosResponseError(err));
    },
  });

  return (
    <Button
      loading={isPending}
      variant="outline"
      onClick={(ev) => {
        ev.stopPropagation();
        mutate();
      }}
      size="xs"
    >
      {isActive ? "deactivate" : "activate"}
    </Button>
  );
}
